export const historyTypes = {
  'export_report_inventory_summary' : 'Inventory Summary Report',
  'export_report_aging_ar'    : 'Aging AR Report',
  'export_report_sales'       : 'Sales COGS Payments',
  'export_report_sales_orders': 'Sales Report',
  'export_products'           : 'Export Products',
  'import_products'           : 'Import Products',
}
